import * as actions from './actions'
import * as mappers from './mappers'
import * as selectors from './selectors'
import reducer from './reducer'

// This domain slice does not have sagas at the moment, but we
// still export an empty object to keep the domain aggregator simple.
const sagas = {}

export default {
  actions,
  mappers,
  reducer,
  sagas,
  selectors,
}
